<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX930, CX931, XC9325, XC9335 MFP">
     CX930, CX931, XC9325, XC9335 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_lv" title="Dro&scaron;ības informācija">
     Dro&scaron;ības informācija
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Apzīmējumi">
      Apzīmējumi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e40" title="Paziņojumi saistībā ar produktu">
      Paziņojumi saistībā ar produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_lv" title="Informācija par printeri">
     Informācija par printeri
    </a>
   </p>
   <div id="divd0e170">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_lv" title="Informācijas atra&scaron;ana par printeri">
      Informācijas atra&scaron;ana par printeri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_lv" title="Printera sērijas numura atra&scaron;ana">
      Printera sērijas numura atra&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_lv" title="Printera konfigurācijas">
      Printera konfigurācijas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_lv" title="Ja lietojat vadības paneli">
      Ja lietojat vadības paneli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_lv" title="Par indikatora gaismas statusu">
      Par indikatora gaismas statusu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e562" title="Papīra izvēle">
      Papīra izvēle
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_lv" title="Uzstādī&scaron;ana, instalē&scaron;ana un konfigurē&scaron;ana">
     Uzstādī&scaron;ana, instalē&scaron;ana un konfigurē&scaron;ana
    </a>
   </p>
   <div id="divd0e3851">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_lv" title="Printera atra&scaron;anās vietas izvēle">
      Printera atra&scaron;anās vietas izvēle
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_lv" title="Kabeļu pievieno&scaron;ana">
      Kabeļu pievieno&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e4039" title="Sākuma ekrāna lietojumprogrammu iestatī&scaron;ana un lieto&scaron;ana">
      Sākuma ekrāna lietojumprogrammu iestatī&scaron;ana un lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e4691" title="Pieejamības funkciju iestatī&scaron;ana un lieto&scaron;ana">
      Pieejamības funkciju iestatī&scaron;ana un lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e4994" title="Faksa funkcijas iestatī&scaron;ana printerī">
      Faksa funkcijas iestatī&scaron;ana printerī
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_lv" title="E-pasta SMTP iestatījumu konfigurē&scaron;ana">
      E-pasta SMTP iestatījumu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#d0e6870" title="Papīra un speciālā apdrukājamā materiāla ievieto&scaron;ana">
      Papīra un speciālā apdrukājamā materiāla ievieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7265" title="Programmatūras, draiveru un programmaparatūras uzstādī&scaron;ana un atjauninā&scaron;ana">
      Programmatūras, draiveru un programmaparatūras uzstādī&scaron;ana un atjauninā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e7547" title="Aparatūras ierīču uzstādī&scaron;ana">
      Aparatūras ierīču uzstādī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e8219" title="Tīklo&scaron;ana">
      Tīklo&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_lv" title="Seriālās drukā&scaron;anas iestatī&scaron;ana (tikai Windows)">
      Seriālās drukā&scaron;anas iestatī&scaron;ana (tikai Windows)
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_lv" title="Printera dro&scaron;ība">
     Printera dro&scaron;ība
    </a>
   </p>
   <div id="divd0e8616">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_lv" title="Dro&scaron;ības slota atra&scaron;ana">
      Dro&scaron;ības slota atra&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_lv" title="Printera atmiņas dzē&scaron;ana">
      Printera atmiņas dzē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_lv" title="Printera krātuves diska dzē&scaron;ana">
      Printera krātuves diska dzē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_lv" title="Rūpnīcas noklusējuma iestatījumu atjauno&scaron;ana">
      Rūpnīcas noklusējuma iestatījumu atjauno&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_lv" title="Paziņojums par energoatkarību">
      Paziņojums par energoatkarību
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_lv" title="Drukāt">
     Drukāt
    </a>
   </p>
   <div id="divd0e8809">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_lv" title="Drukā&scaron;ana no datora">
      Drukā&scaron;ana no datora
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e8835" title="Drukā&scaron;ana no mobilās ierīces">
      Drukā&scaron;ana no mobilās ierīces
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_lv" title="Drukā&scaron;ana no zibatmiņas diska">
      Drukā&scaron;ana no zibatmiņas diska
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_lv" title="Atbalstīto zibatmiņas disku un failu veidi">
      Atbalstīto zibatmiņas disku un failu veidi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_lv" title="Konfidenciālu darbu konfigurē&scaron;ana">
      Konfidenciālu darbu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_lv" title="Konfidenciālu un citu aizturētu darbu drukā&scaron;ana">
      Konfidenciālu un citu aizturētu darbu drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_lv" title="Fontu paraugu saraksta drukā&scaron;ana">
      Fontu paraugu saraksta drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_lv" title="Direktoriju saraksta drukā&scaron;ana">
      Direktoriju saraksta drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_lv" title="Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem">
      Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_lv" title="Izdrukāto lapu skavo&scaron;ana">
      Izdrukāto lapu skavo&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_lv" title="Caurumo&scaron;ana izdrukātās lapās">
      Caurumo&scaron;ana izdrukātās lapās
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_lv" title="Kaudzī&scaron;u ofseta lieto&scaron;ana izdrukātajās lapās">
      Kaudzī&scaron;u ofseta lieto&scaron;ana izdrukātajās lapās
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_lv" title="Drukas darba atcel&scaron;ana">
      Drukas darba atcel&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_lv" title="Tonera intensitātes koriģē&scaron;ana">
      Tonera intensitātes koriģē&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying-chapter.html#copying-chapter_lv" title="Kopē&scaron;ana">
     Kopē&scaron;ana
    </a>
   </p>
   <div id="divd0e9600">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_lv" title="Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana">
      Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_lv" title="Kopē&scaron;ana">
      Kopē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_lv" title="Fotoattēlu kopē&scaron;ana">
      Fotoattēlu kopē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_lv" title="Kopē&scaron;ana uz veidlapām">
      Kopē&scaron;ana uz veidlapām
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_lv" title="Kopē&scaron;ana uz abām papīra pusēm">
      Kopē&scaron;ana uz abām papīra pusēm
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_lv" title="Kopiju samazinā&scaron;ana vai palielinā&scaron;ana">
      Kopiju samazinā&scaron;ana vai palielinā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_lv" title="Kopiju salik&scaron;ana">
      Kopiju salik&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_lv" title="Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem">
      Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_lv" title="Vairāku lapu kopē&scaron;ana uz vienas loksnes">
      Vairāku lapu kopē&scaron;ana uz vienas loksnes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_lv" title="Kar&scaron;u kopē&scaron;ana">
      Kar&scaron;u kopē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-copies-topic.html#stapling-copies_lv" title="Kopiju skavo&scaron;ana">
      Kopiju skavo&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-copies-topic.html#punching-holes-copies_lv" title="Caurumo&scaron;ana kopijās">
      Caurumo&scaron;ana kopijās
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-copies-topic.html#using-offset-stacking-copies_lv" title="Kaudzī&scaron;u ofseta lieto&scaron;ana kopijām">
      Kaudzī&scaron;u ofseta lieto&scaron;ana kopijām
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_lv" title="Kopē&scaron;anas īsceļa izveide">
      Kopē&scaron;anas īsceļa izveide
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_lv" title="E-pasts:">
     E-pasts:
    </a>
   </p>
   <div id="divd0e9979">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_lv" title="Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana">
      Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_lv" title="E-pasta ziņojuma sūtī&scaron;ana">
      E-pasta ziņojuma sūtī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_lv" title="E-pasta īsceļa izveide">
      E-pasta īsceļa izveide
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="faxing-chapter.html#faxing-chapter_lv" title="Fakss">
     Fakss
    </a>
   </p>
   <div id="divd0e10073">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_lv" title="Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana">
      Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_lv" title="Faksa sūtī&scaron;ana">
      Faksa sūtī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_lv" title="Faksa ieplāno&scaron;ana">
      Faksa ieplāno&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_lv" title="Faksa galamērķa īsceļa izveide">
      Faksa galamērķa īsceļa izveide
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_lv" title="Faksa iz&scaron;ķirtspējas maiņa">
      Faksa iz&scaron;ķirtspējas maiņa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_lv" title="Faksa intensitātes koriģē&scaron;ana">
      Faksa intensitātes koriģē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_lv" title="Faksa žurnāla drukā&scaron;ana">
      Faksa žurnāla drukā&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_lv" title="Nevēlamu faksu bloķē&scaron;ana">
      Nevēlamu faksu bloķē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_lv" title="Faksu aizturē&scaron;ana">
      Faksu aizturē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_lv" title="Faksa pāradresē&scaron;ana">
      Faksa pāradresē&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="ftp-chapter.html#ftp-chapter_lv" title="Skenē&scaron;ana">
     Skenē&scaron;ana
    </a>
   </p>
   <div id="divd0e10437">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_lv" title="Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana">
      Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_lv" title="Skenē&scaron;ana uz datoru">
      Skenē&scaron;ana uz datoru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_lv" title="Skenē&scaron;ana uz FTP serveri">
      Skenē&scaron;ana uz FTP serveri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_lv" title="FTP īsceļa izveide">
      FTP īsceļa izveide
     </a>
    </p>
    <p class="toc-2-style">
     <a href="s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_lv" title="Skenē&scaron;ana tīkla mapē">
      Skenē&scaron;ana tīkla mapē
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_lv" title="Tīkla mapes īsceļa izveide">
      Tīkla mapes īsceļa izveide
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_lv" title="Skenē&scaron;ana uz zibatmiņas disku">
      Skenē&scaron;ana uz zibatmiņas disku
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_lv" title="Printera izvēļņu izmanto&scaron;ana">
     Printera izvēļņu izmanto&scaron;ana
    </a>
   </p>
   <div id="divd0e10739">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_lv" title="Izvēļņu karte">
      Izvēļņu karte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e11102" title="Ierīce">
      Ierīce
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e13477" title="Drukāt">
      Drukāt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e14883" title="Papīrs">
      Papīrs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e15252" title="Kopē&scaron;ana">
      Kopē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e15914" title="Fakss">
      Fakss
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e18319" title="E-pasts:">
      E-pasts:
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e19369" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e19954" title="USB disks">
      USB disks
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e20812" title="Tīkls/porti">
      Tīkls/porti
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e23002" title="Cloud Services">
      Cloud Services
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e23059" title="Dro&scaron;ība">
      Dro&scaron;ība
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e24247" title="Atskaites">
      Atskaites
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_lv" title="Problēmu novēr&scaron;ana">
      Problēmu novēr&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_lv" title="Izvēļņu iestatījumu lapas drukā&scaron;ana">
      Izvēļņu iestatījumu lapas drukā&scaron;ana
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_lv" title="Printera uzturē&scaron;ana">
     Printera uzturē&scaron;ana
    </a>
   </p>
   <div id="divd0e24587">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_lv" title="Detaļu un izejmateriālu statusa pārbaude">
      Detaļu un izejmateriālu statusa pārbaude
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_lv" title="Izejmateriālu paziņojumu konfigurē&scaron;ana">
      Izejmateriālu paziņojumu konfigurē&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_lv" title="E-pasta brīdinājumu iestatī&scaron;ana">
      E-pasta brīdinājumu iestatī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_lv" title="Atskai&scaron;u skatī&scaron;ana">
      Atskai&scaron;u skatī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-supplies-group_lv" title="Detaļu un izejmateriālu pasūtī&scaron;ana">
      Detaļu un izejmateriālu pasūtī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e24896" title="Detaļu un izejmateriālu nomaiņa">
      Detaļu un izejmateriālu nomaiņa
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e25566" title="Printera detaļu tīrī&scaron;ana">
      Printera detaļu tīrī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e25834" title="Enerģijas un papīra taupī&scaron;ana">
      Enerģijas un papīra taupī&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_lv" title="Printera pārvieto&scaron;ana uz citu vietu">
      Printera pārvieto&scaron;ana uz citu vietu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_lv" title="Printera piegāde">
      Printera piegāde
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_lv" title="Problēmas novēr&scaron;ana">
     Problēmas novēr&scaron;ana
    </a>
   </p>
   <div id="divd0e25988">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_lv" title="Drukas kvalitātes problēmas">
      Drukas kvalitātes problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_lv" title="Printera kļūdu kodi">
      Printera kļūdu kodi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_lv" title="Drukā&scaron;anas problēmas">
      Drukā&scaron;anas problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_lv" title="Printeris nereaģē">
      Printeris nereaģē
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_lv" title="Nevar lasīt zibatmiņas disku">
      Nevar lasīt zibatmiņas disku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_lv" title="USB porta iespējo&scaron;ana">
      USB porta iespējo&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#d0e29524" title="Iestrēgu&scaron;a papīra izņem&scaron;ana">
      Iestrēgu&scaron;a papīra izņem&scaron;ana
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e30034" title="Tīkla savienojuma problēmas">
      Tīkla savienojuma problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e30262" title="Aparatūras ierīču problēmas">
      Aparatūras ierīču problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e30388" title="Izejmateriālu problēmas">
      Izejmateriālu problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e30493" title="Papīra padeves problēmas">
      Papīra padeves problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e30859" title="E-pasta ziņojumu sūtī&scaron;anas problēmas">
      E-pasta ziņojumu sūtī&scaron;anas problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e30953" title="Faksa sūtī&scaron;anas problēmas">
      Faksa sūtī&scaron;anas problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e31598" title="Skenē&scaron;anas problēmas">
      Skenē&scaron;anas problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e32372" title="Krāsas kvalitātes problēmas">
      Krāsas kvalitātes problēmas
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_lv" title="Sazinā&scaron;anās ar klientu atbalstu">
      Sazinā&scaron;anās ar klientu atbalstu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_lv" title="Otrreizējā pārstrāde un atbrīvo&scaron;anās">
     Otrreizējā pārstrāde un atbrīvo&scaron;anās
    </a>
   </p>
   <div id="divd0e32622">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_lv" title="Lexmark produktu otrreizēja pārstrāde">
      Lexmark produktu otrreizēja pārstrāde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_lv" title="Lexmark iepakojuma otrreizēja pārstrāde">
      Lexmark iepakojuma otrreizēja pārstrāde
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_lv" title="Paziņojumi">
     Paziņojumi
    </a>
   </p>
   <div id="divd0e32657">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e32660" title="Produkta informācija">
      Produkta informācija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e32677" title="Izdevuma paziņojums">
      Izdevuma paziņojums
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_lv" title="Preču zīmes">
      Preču zīmes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_lv" title="Paziņojumi par licencē&scaron;anu">
      Paziņojumi par licencē&scaron;anu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_lv" title="Trok&scaron;ņu emisijas līmeņi">
      Trok&scaron;ņu emisijas līmeņi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_lv" title="Atkritumu savāk&scaron;ana atbilsto&scaron;i Elektrisko un elektronisko iekārtu direktīvai (EEIA)">
      Atkritumu savāk&scaron;ana atbilsto&scaron;i Elektrisko un elektronisko iekārtu direktīvai (EEIA)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e32782" title="Litija jonu lādējama baterija">
      Litija jonu lādējama baterija
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_lv" title="Regula (EU) 2023/1542">
      Regula (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e32820" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_lv" title="Atbrīvo&scaron;anās no produkta">
      Atbrīvo&scaron;anās no produkta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_lv" title="Lexmark kasetņu atgrie&scaron;ana atkārtotai izmanto&scaron;anai un pārstrādei">
      Lexmark kasetņu atgrie&scaron;ana atkārtotai izmanto&scaron;anai un pārstrādei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_lv" title="Paziņojums par jutību pret statisko elektrību">
      Paziņojums par jutību pret statisko elektrību
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_lv" title="Emblēma &ldquo;ENERGY STAR&rdquo;">
      Emblēma &ldquo;ENERGY STAR&rdquo;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_lv" title="Informācija par temperatūru">
      Informācija par temperatūru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_lv" title="Jaudas patēriņ&scaron;">
      Jaudas patēriņ&scaron;
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_lv" title="Reglamentējo&scaron;i paziņojumi par telekomunikāciju termināla iekārtu">
      Reglamentējo&scaron;i paziņojumi par telekomunikāciju termināla iekārtu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_lv" title="Atbilstība Eiropas Kopienas (EK) direktīvām">
      Atbilstība Eiropas Kopienas (EK) direktīvām
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_lv" title="Paziņojums par radioviļņu ietekmi">
      Paziņojums par radioviļņu ietekmi
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue